document.documentElement.classList.remove('no-js');
document.addEventListener('click', function (event) {
  const toggle = event.target.closest('[data-drawer-toggle]');
  if (toggle) document.documentElement.classList.toggle('drawer-open');
  const close = event.target.closest('[data-drawer-close]');
  if (close) document.documentElement.classList.remove('drawer-open');
});
